
import { get,post,prefix} from './base'


//获取个人实名认证信息
export function getPersonCertify(params) {
    return get(prefix+'esign/getPersonCertify', params)
}

//个人实名手机验证码验证
export function personCertifyMobile (params) {
    return get(prefix+'esign/personCertifyMobile', params)
}

//重新获取个人实名认证手机验证码
export function reStartPersonCertify (params) {
    return get(prefix+'esign/reStartPersonCertify', params)
}



export function startPersonCertify (params) {
    return post(prefix+'esign/startPersonCertify', params)
}



//获取企业实名认证信息
export function getCorpCertifyInfo (params) {
    return get(prefix+'esign/getCorpCertifyInfo', params)
}


// 发起企业实名认证流程
export function createCorpCertify (params) {
    return post(prefix+'esign/createCorpCertify', params)
}


// 通过银行名称模糊匹配银行信息
export function listBankInfo (params) {
    return get(prefix+'esign/listBankInfo', params)
}



// 通过企业名称模糊匹配企业信息
export function listCorpInfo (params) {
    return get(prefix+'esign/listCorpInfo', params)
}

// // 获取企业实名认证信息 
// export function getCertifyBankInfo (params) {
//   return get(prefix+'esign/getCertifyBankInfo', params)
// }

// 发起打款认证流程
export function createRemitCertity (params) {
    return post(prefix+'esign/createRemitCertity', params)
}


// 重新发起打款认证流程
export function reCreateRemitCertity (params) {
    return post(prefix+'esign/reCreateRemitCertity', params)
}


// 对公打款认证
export function remitCertity (params) {
    return post(prefix+'esign/remitCertity', params)
}



// 获取今日打款剩余次数
export function getRemitCout (params) {
    return get(prefix+'esign/getRemitCout', params)
}


// 重置流程节点
export function resetProcess (String) {
    return get(prefix+'esign/resetProcess', String)
}




// 获取经办人信息
export function getAgent (params) {
    return get(prefix+'esign/getAgent', params)
}



//获取验证码
export function requestSMSCode (params) {
    return get(prefix+'esign/requestSMSCode', params)
}

// 更改手机号 权限校验
export function updateMobileAuth (params) {
    return post(prefix+'esign/updateMobileAuth', params)
}


// 修改绑定手机
export function updateMobile (params) {
    return post(prefix+'esign/updateMobile', params)
}


// 获取打款进度
export function getRemitProcess (params) {
    return get(prefix+'esign/getRemitProcess', params)
}

// 重置密码  
export function resetPassword (params) {
    return post(prefix+'platform/resetPassword', params)
}


// 重置密码  
export function resetPasswordAuth (params) {
    return post(prefix+'esign/resetPasswordAuth', params)
}


// 重置个人密码
export function resetPasswordNew (params) {
    return post(prefix+'esign/resetPasswordNew', params)
}

// 获取跳转域名
export function getSubDomain (params) {
    return get(prefix+'esign/getSubDomain', params)
}